module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/client/my-support/my-support.component.scss
// module id = ./src/app/pages/client/my-support/my-support.component.scss
// module chunks = main